class CoverFix {
  constructor(el) {
    this.fixCovers(el);
  }

  fixCovers(el) {
    const img = el.querySelector('img');

    el.style.backgroundImage = `url(${img.src})`;
    el.removeChild(img);
  };
}

export default CoverFix;
